module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"rynh","short_name":"rynh","start_url":"/","background_color":"#0A0A0A","theme_color":"#0A0A0A","display":"standalone","icon":"static/icon-512.png","include_favicon":false,"legacy":false,"icons":[{"src":"/icon-192.png","sizes":"192x192","type":"image/png"},{"src":"/icon-512.png","sizes":"512x512","type":"image/png"},{"src":"/icon-512.png","sizes":"512x512","type":"image/png","purpose":"maskable"}],"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"f2f4da2ab6bcb6d94f1d05b40875ea99"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
